import React from "react";
import ReactDOM from "react-dom";
import {Provider} from './components/utils.jsx';
import poly from "poly-js-utils";
import css from "./common/dynamic-css-loader.js";
import AboutPage from "./components/about_page";

poly.KalturaHelpers.init();
css.loadDynamicCss();

ReactDOM.render(
    <Provider JSContext={window.JSContext}>
        <AboutPage />
    </Provider>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./about-me.js